// extracted by mini-css-extract-plugin
export default {"title":"Changelog_title__8Ahvp","new":"Changelog_new__PEYai","overflow":"Changelog_overflow__lTJNS"};